export const PROOF_OF_ADDRESS_IMAGE_TYPES = Object.freeze([
  'image/jpeg',
  'image/png',
  'image/webp',
]);

export const PROOF_OF_ADDRESS_FILE_TYPES = Object.freeze([
  ...PROOF_OF_ADDRESS_IMAGE_TYPES,
  'application/pdf',
]);

export function isProofOfAddressImage(file) {
  if (!file) return false;
  return PROOF_OF_ADDRESS_IMAGE_TYPES.includes(file.type);
}

export function isAllowedProofOfAddressFile(file) {
  if (!file) return false;
  if (PROOF_OF_ADDRESS_FILE_TYPES.includes(file.type)) return true;
  return /\.pdf$/i.test(file.name || '');
}
